import { RenderSchema } from '../../utils/FormRenderer'
import { CreateTrackerSchema } from '../../utils/FormSchemas'

export const CreateTrackerModal = ({ form, data: { record } }) => {
	return (
		<div className='flex flex-col py-3 px-6 h-full w-full overflow-y-auto content-center'>
			<div>{RenderSchema(CreateTrackerSchema())}</div>
		</div>
	)
}
